import { Link } from 'react-router-dom';

export function PublicFooter(): JSX.Element {
  const year = new Date().getFullYear();
  return (
    <footer className="mx-auto mt-24 max-w-6xl px-4 pb-10 sm:px-6">
      <div className="glass flex flex-col gap-4 rounded-3xl border border-white/20 px-6 py-6 text-sm text-muted-foreground shadow-xl dark:border-white/10 sm:flex-row sm:items-center sm:justify-between">
        <p className="text-foreground">© {year} InspectAI. Crafted for property inspection teams.</p>
        <div className="flex flex-wrap items-center gap-4">
          <Link to="/security" className="transition hover:text-foreground">
            Security & privacy
          </Link>
          <Link to="/pricing" className="transition hover:text-foreground">
            Pricing
          </Link>
          <a
            href="mailto:raykundan57@gmail.com"
            target="_blank"
            rel="noreferrer"
            className="transition hover:text-foreground"
          >
            Contact
          </a>
        </div>
      </div>
    </footer>
  );
}
